//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getSuggestFollow, getFollowings } from '~/api/user';
import BtnFollow from '~/components/public/btn-follow';
import { linkPage } from '~/utils/util';

export default {
  name: 'RecommendUserWidget',
  components: {
    BtnFollow,
  },
  data() {
    return {
      list: [],
      followList: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const data = await $axios(getSuggestFollow({ page: 1, count: 6 })).catch(
      () => {}
    );
    if (data.result) {
      this.list = data?.result ?? [];
    } else {
      const followData = await $axios(
        getFollowings({ page: 1, count: 6, id: this.userId })
      ).catch(() => {});
      this.followList = followData?.result ?? [];
    }
  },
  computed: {
    ...mapGetters('user', ['isFollow', 'userId']),
  },
  methods: {
    linkPage(url, type = '_blank') {
      linkPage(url, type);
    },
  },
};
